namespace InvData.BinarySearchHelper {
  export function binarySearch(arr: any, compareFunc: (x: any) => number) {
    if (!arr || arr.length <= 1) {
      return -1;
    }

    let left = 0;
    let right = arr.length - 1;

    while (left <= right) {
      const mid = Math.floor((left + right) / 2);
      const compare = compareFunc(arr[mid]);

      if (compare === 0) {
        return mid;
      } else if (compare < 0) {
        left = mid + 1;
      } else {
        right = mid - 1;
      }
    }

    return -1;
  }
}